<template>
    <v-app inspire>
        <v-toolbar :color="setting.color" v-if="setting.isShow" dark fixed dense app clipped-right>
        <v-flex xs4>
            <v-toolbar-title @click="toHome" style="cursor:pointer">
            <label style="font-size:24px;font-weight:bold">{{setting.header}}</label>
            <label>-{{setting.subheader}}</label>
            </v-toolbar-title>
        </v-flex>
        <v-spacer></v-spacer>
        </v-toolbar>
        <v-content>
            <v-container fluid pa-0>
                <v-layout>
                    <v-flex>
                        <v-layout column>
                            <keep-alive :max="10">
                                <router-view/>
                            </keep-alive>
                        </v-layout>
                    </v-flex>
                 </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<style scoped>
</style>

<script>
import Index from "./index.ts";
export default Index;
</script>